/* eslint-disable react/prop-types */
import React, { memo, useCallback } from 'react';
import { AiGalleryPanel } from '../../ChatDSTemplate/components/AiGallery/AiGalleryPanel';
import type { ChatDSTemplateActionsListProps } from '../../ChatDSTemplate/type';

/** 从 ChatDSTemplateActionsListProps 中提取分享场景所需的类型 */
type IChatAiGalleryShareProps = Pick<ChatDSTemplateActionsListProps, 'dsReport' | 'sessionId' | 'handleUpdateDsReport'>;

/**
 * 分享场景下的 AiGallery 只读包装组件
 * 职责：从分享场景的 props 中适配出 AiGalleryPanel 所需的 props
 * 固定传入 showPublish={false} 以隐藏发布按钮，保留关闭按钮
 */
const ChatAiGalleryShare: React.FC<IChatAiGalleryShareProps> = memo(({
  dsReport,
  sessionId,
  handleUpdateDsReport,
}) => {
  // 分享场景下不需要发起新对话，提供空函数
  const noop = useCallback(() => {}, []);

  return (
    <AiGalleryPanel
      dsReport={dsReport}
      handleUpdateDsReport={handleUpdateDsReport}
      startNewConversation={noop as any}
      sessionId={sessionId as string}
      streamingState=""
      showPublish={false}
    />
  );
});

ChatAiGalleryShare.displayName = 'ChatAiGalleryShare';

export default ChatAiGalleryShare;
